import { render, staticRenderFns } from "./mesRelevanceDevice.vue?vue&type=template&id=df243230&scoped=true&"
import script from "./mesRelevanceDevice.vue?vue&type=script&lang=js&"
export * from "./mesRelevanceDevice.vue?vue&type=script&lang=js&"
import style0 from "./mesRelevanceDevice.vue?vue&type=style&index=0&id=df243230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df243230",
  null
  
)

export default component.exports